import React, { FC } from 'react';
import { formatFileSize } from 'utils/helpers';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';
import { getFileIcon } from './../note';

interface IEntityDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: Record<string, any>[];
}

export const AttachmentDrawer: FC<IEntityDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Attachments'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row gutter={[0, 16]}>
        {data?.map((attachment) => (
          <Col key={attachment.id} span={24}>
            <Row gutter={[12, 0]} align={'middle'} wrap={false}>
              <Col>
                <Button
                  type="link"
                  icon={getFileIcon(attachment.extension)}
                  download
                  title={attachment.fileName}
                  rel="noopener noreferrer"
                  href={attachment.files?.ATTACHMENTS}
                />
              </Col>
              <Col>
                <Row>
                  <Col span={24}>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      style={{ maxWidth: '380px' }}
                      className={'font-size-12 font-weight-500'}
                    >
                      {attachment.fileName}
                    </Typography.Text>
                  </Col>
                  <Col>
                    <Typography.Text className={'font-size-12'}>{formatFileSize(attachment.size || 0)}</Typography.Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
